// components/UserFilter.tsx
import { Autocomplete, Popper, PopperProps, TextField } from "@mui/material";

type Option = {
  label: string;
  id: number;
};

type Props = {
  options: Option[];
  onSelect: (id: number | null) => void;
  sx?: any;
  labelFontSize?: string;
  value?: number | null;
  isDisabled?: boolean;
};

const UserFilterSelect = ({
  options,
  onSelect,
  sx,
  labelFontSize = "1.0rem",
  value,
  isDisabled = false,
}: Props) => {
  const CustomPopper = (props: PopperProps) => {
    return (
      <Popper
        {...props}
        style={{
          ...props.style,
          width: props.anchorEl
            ? (props.anchorEl as HTMLElement).clientWidth
            : undefined,
          zIndex: 4000,
        }}
        placement="bottom-start"
      />
    );
  };
  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.label}
      value={options.find((opt) => opt.id === value) || null}
      onChange={(_, value) => onSelect(value ? value.id : null)}
      renderInput={(params) => (
        <TextField
          {...params}
          label="ユーザーを検索"
          variant="outlined"
          size="small"
          InputLabelProps={{
            sx: { fontSize: labelFontSize },
          }}
          disabled={isDisabled}
        />
      )}
      PopperComponent={CustomPopper}
      fullWidth
      clearOnEscape
      sx={sx}
      disabled={isDisabled}
    />
  );
};

export default UserFilterSelect;
